import React from 'react'
import { Select, InputNumber } from 'antd'
import { Label } from "../../../../../common/Label/Label"
import styles from '../../Layout/AnalyticsLayout.module.scss'
import { IPlotVariable } from "../../../../../../types/analytics"

interface RosePlotAdditionalControlsProps {
  directions: IPlotVariable[]
  direction: IPlotVariable | null
  onDirectionChange: (directionIndex: number) => void
  directionNo: number
  degreeIntervals: number[]
  onChangeDirectionNo: (value: number) => void
  legendInterval: number
  onChangeIntervalNo: (value: number | null) => void
  isLoading?: boolean
  hasError?: boolean
}

export const RosePlotAdditionalControls = ({
   directions,
   direction,
   onDirectionChange,
   directionNo,
   degreeIntervals,
   onChangeDirectionNo,
   legendInterval,
   onChangeIntervalNo,
   isLoading = false,
   hasError = false
 }: RosePlotAdditionalControlsProps) => {

  return (
    <div className={styles.additionalControlsContainer}>
      <div className={styles.controlItem}>
        <Label label="Direction">
          <Select
            value={direction?.Index ? direction.Index : 0}
            style={{ width: '100%' }}
            onChange={onDirectionChange}
            disabled={isLoading || hasError}
          >
            {directions.map((item) => (
              <Select.Option key={item.Index} value={item.Index}>
                {item.Name}
              </Select.Option>
            ))}
          </Select>
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label="No. of Directions">
          <Select
            value={directionNo}
            style={{ width: '100%' }}
            onChange={onChangeDirectionNo}
            disabled={isLoading || hasError}
          >
            {degreeIntervals.map((interval) => (
              <Select.Option key={interval} value={interval}>
                {interval}
              </Select.Option>
            ))}
          </Select>
        </Label>
      </div>

      <div className={styles.controlItem}>
        <Label label="Legend Intervals">
          <InputNumber
            value={legendInterval}
            precision={2}
            min={0.01}
            onChange={onChangeIntervalNo}
            disabled={isLoading || hasError}
            style={{ width: '100%' }}
          />
        </Label>
      </div>
    </div>
  )
}

export type { RosePlotAdditionalControlsProps }
